import { blogAPI } from '../api/blog';
import { actionWrapper } from './actionWrapper';

export const SET_BLOGS = 'SET_BLOGS';
export const SET_BLOG = 'SET_BLOG';

export const getBlogs = () => actionWrapper(async () => {
  const blogsData = await blogAPI.getBlogs();
  return {
    type: SET_BLOGS,
    payload: blogsData,
  };
});

export const getBlogById = (id) => actionWrapper(async () => {
  const blogData = await blogAPI.getBlogById(id);
  
  return {
    type: SET_BLOG,
    payload: blogData,
  };
});